import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { ToastProvider } from '@/components/ui/ToastProvider'
import { useMeQuery } from '@/features/auth/hooks/useAuth'
import { queryClient } from '@/lib/queryClient'
import { router } from '@/routes/router'

function AppShell() {
  // Hydrates the auth store from the session cookie on every app boot —
  // a 401 here just means "not signed in", handled inside the hook itself.
  useMeQuery()

  return <RouterProvider router={router} />
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AppShell />
      </ToastProvider>
    </QueryClientProvider>
  )
}
